import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { concatMap, filter, map, withLatestFrom } from "rxjs/operators";

import { selectActiveFilterId, selectActiveIdAndFilter } from "../selectors/filters.selectors";
import {
	Set,
	SetForFilter,
	UnsetForFilter,
	FilterActionTypes,
	InitializeFilter,
	UnSet,
	Clear,
	ClearForFilter,
	SetRoomOnNfcScanForFilter,
	SetRoomOnNfcScan,
} from "../actions/data/action-creators/filters.actions";

@Injectable()
export class FiltersEffects {
	private store = inject<Store<any>>(Store);
	private actions$ = inject(Actions);

	syncState$ = createEffect(() => {
		return this.store.select(selectActiveIdAndFilter).pipe(
			filter((filter) => filter.filterId !== undefined && filter.filter === undefined),
			map((filter) => new InitializeFilter({ filterId: filter.filterId })),
		);
	});

	set$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(FilterActionTypes.Set),
			concatMap((action: Set) => of(action).pipe(withLatestFrom(this.store.select(selectActiveFilterId)))),
			filter(([, filterId]) => filterId !== undefined),
			map(([action, filterId]) => new SetForFilter({ filterId, filterOptions: action.payload })),
		);
	});

	setRoomOnNfcScan$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(FilterActionTypes.SetRoomOnNfcScan),
			concatMap((action: SetRoomOnNfcScan) => of(action).pipe(withLatestFrom(this.store.select(selectActiveFilterId)))),
			filter(([, filterId]) => filterId !== undefined),
			map(([action, filterId]) => new SetRoomOnNfcScanForFilter({ filterId, room: action.payload.room })),
		);
	});

	clear$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(FilterActionTypes.Clear),
			concatMap((action: Clear) => of(action).pipe(withLatestFrom(this.store.select(selectActiveFilterId)))),
			filter(([, filterId]) => filterId !== undefined),
			map(([, filterId]) => new ClearForFilter({ filterId })),
		);
	});

	unset$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(FilterActionTypes.Unset),
			concatMap((action: UnSet) => of(action).pipe(withLatestFrom(this.store.select(selectActiveFilterId)))),
			filter(([, filterId]) => filterId !== undefined),
			map(([action, filterId]) => new UnsetForFilter({ filterId, ...action.payload })),
		);
	});
}
